import type { CSSProperties } from 'react';
import { FIGURE_PICKER_COLORS } from '../constants';
import { FIGURE_LABELS, type NoteFigure } from '../types';
import { FigureIcon } from './FigureIcon';

const FIGURES: NoteFigure[] = ['redonda', 'blanca', 'negra', 'corchea', 'semicorchea'];

interface Props {
  slotFigure: NoteFigure;
  selectedFigure: NoteFigure;
  onPick: (figure: NoteFigure) => void;
}

export function BeatFigureContextBar({ slotFigure, selectedFigure, onPick }: Props) {
  return (
    <div
      className="beat-figure-context"
      role="toolbar"
      aria-label="Figuras para este tiempo"
      onPointerDown={(e) => e.stopPropagation()}
    >
      {FIGURES.map((f) => {
        const active = selectedFigure === f || slotFigure === f;
        return (
          <button
            key={f}
            type="button"
            className={`beat-figure-context__btn ${active ? 'beat-figure-context__btn--active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onPick(f);
            }}
            aria-pressed={active}
            aria-label={FIGURE_LABELS[f]}
            title={FIGURE_LABELS[f]}
          >
            <span
              className="beat-figure-context__dot"
              style={{ '--fig-color': FIGURE_PICKER_COLORS[f] } as CSSProperties}
            >
              <FigureIcon figure={f} display="picker" size={26} className="beat-figure-context__icon" />
            </span>
          </button>
        );
      })}
    </div>
  );
}
